import { InteractiveEducationLayout } from './InteractiveEducationLayout';
import { useInteractiveEducation } from '../hooks/useInteractiveEducation';
import { useInteractiveEducationProps } from '../hooks/useInteractiveEducationProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const VideoContentWithInteractiveEducation = ({
  creatorRegion,
  lessonContentId,
  contentType,
  videoId,
  contentPortalId,
  videoTitle,
  interactiveContentTrackingProps,
  children,
  primaryContentId,
  language
}) => {
  const {
    displayInteractiveEducation,
    handleDisplayInteractiveEducation,
    interactiveEducationEnabled,
    enableAdaptToIndustry
  } = useInteractiveEducation({
    videoId,
    creatorRegion,
    contentPortalId,
    interactiveContentTrackingProps
  });
  const interactiveEducationProps = useInteractiveEducationProps({
    primaryContentId,
    contentType,
    language,
    lessonContentId,
    interactiveContentTrackingProps
  });
  return /*#__PURE__*/_jsx(InteractiveEducationLayout, {
    contentPortalId: contentPortalId,
    contentType: contentType,
    displayInteractiveEducation: displayInteractiveEducation,
    enableAdaptToIndustry: enableAdaptToIndustry,
    interactiveContentTrackingProps: interactiveContentTrackingProps,
    interactiveEducationEnabled: interactiveEducationEnabled,
    interactiveEducationProps: interactiveEducationProps,
    language: language,
    lessonContentId: lessonContentId,
    primaryContentId: primaryContentId,
    videoId: videoId,
    videoTitle: videoTitle,
    children: children({
      displayInteractiveEducation,
      handleDisplayInteractiveEducation,
      interactiveEducationEnabled,
      enableAdaptToIndustry,
      generateQuizLoading: interactiveEducationProps.generateQuizLoading
    })
  });
};
export default VideoContentWithInteractiveEducation;